import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ContaPagar } from '../page/conta-pagar/contapagar';
import { PaginacaoContaPagar } from '../page/conta-pagar/paginacaoContaPagar';

@Injectable({
  providedIn: 'root'
})
export class ContaPagarService {

  apiURL: string = environment.apiBaseUrl + 'contaPagar';

  constructor(private http: HttpClient) { }

  save(contaPagar: ContaPagar): Observable<ContaPagar> {
    return this.http.post<ContaPagar>(this.apiURL, contaPagar);
  }

  list(page: number, size: number): Observable<PaginacaoContaPagar> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  update(contaPagar: ContaPagar): Observable<any> {
    return this.http.put<ContaPagar>(`${this.apiURL}/${contaPagar.id}`, contaPagar);
  }

  findClientById(id: number): Observable<ContaPagar> {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }

  findClientByIdActive(id: number): Observable<ContaPagar> {
    return this.http.get<any>(`${this.apiURL}/active/${id}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }

  findContaPagar(page: number, size: number , dataInicio: string, dataFim: string,tipoFiltro: string,favorecido:string, situacao?: string | null): Observable<PaginacaoContaPagar> {
    let params = new HttpParams().set('page', page.toString()).set('size', size.toString()).set('dataInicio', dataInicio).set('dataFim', dataFim).set('tipoFiltro', tipoFiltro).set('favorecido', favorecido);
    if (situacao) {
      params = params.set('situacao', situacao);
    }
    return this.http.get<any>(`${this.apiURL}/consulta?${params.toString()}`);
  }

  registrarBaixa(id: number, formaPagamento: string, valor: number | null, dataPagamento: string, arquivo: File | null): Observable<ContaPagar> {
    const formData = new FormData();
    formData.append('formaPagamento', formaPagamento);
    if (arquivo) {
      formData.append('arquivo', arquivo, arquivo.name);
    }
    if (valor != null) {
      formData.append('valor', String(valor));
    }
    if (dataPagamento) {
      formData.append('dataPagamento', dataPagamento);
    }
    return this.http.post<ContaPagar>(`${this.apiURL}/${id}/baixa`, formData);
  }

  anexarFatura(id: number, arquivo: File): Observable<ContaPagar> {
    const formData = new FormData();
    formData.append('arquivo', arquivo, arquivo.name);
    return this.http.post<ContaPagar>(`${this.apiURL}/${id}/anexo/fatura`, formData);
  }

  downloadAnexo(id: number, tipo: 'fatura' | 'baixa'): Observable<Blob> {
    return this.http.get(`${this.apiURL}/${id}/anexo/${tipo}`, { responseType: 'blob' });
  }
}